<div id="drug-sales-analysis" *ngIf="metaReady">
  <div id="drug-sales-analysis-summary-section-container">
    <div class="container-shadow">
      <app-drug-sales-analysis-summary-section [dataSettings]="dataSettings">
      </app-drug-sales-analysis-summary-section>
    </div>
  </div>
  <div id="drug-sales-analysis-grid-and-controls-container">
    <div class="container-shadow">
      <div id="drug-sales-analysis-controls">
        <app-drug-page-grid-controls
          [periodRange]="periodRange"
          (dataSettingsChanged)="dataSettingsChanged($event)"
        ></app-drug-page-grid-controls>
      </div>
      <div id="drug-sales-analysis-grid-section-container">
        <app-drug-sales-analysis-grid-section [dataSettings]="dataSettings">
        </app-drug-sales-analysis-grid-section>
      </div>
    </div>
  </div>
</div>
